import { setAuthToken } from './authToken'
export default setAuthToken
